import { render, staticRenderFns } from "./AdditionalCostsScreen.vue?vue&type=template&id=a99eea86"
import script from "./AdditionalCostsScreen.vue?vue&type=script&lang=js"
export * from "./AdditionalCostsScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports